@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.chat.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.chat.resources/"

@delegate:ResourceContentHash(-442_233_809)
internal val Res.string.people_map_pin_a11y: StringResource by lazy {
      StringResource("string:people_map_pin_a11y", "people_map_pin_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8892, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6920, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6052, 47),
      ))
    }

@delegate:ResourceContentHash(623_763_922)
internal val Res.string.people_map_title: StringResource by lazy {
      StringResource("string:people_map_title", "people_map_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8956, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6980, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6100, 40),
      ))
    }

@delegate:ResourceContentHash(440_734_627)
internal val Res.string.people_map_toggle: StringResource by lazy {
      StringResource("string:people_map_toggle", "people_map_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9308, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7196, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6292, 57),
      ))
    }

@delegate:ResourceContentHash(1_224_180_751)
internal val Res.string.people_map_toggle_desc: StringResource by lazy {
      StringResource("string:people_map_toggle_desc", "people_map_toggle_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9033, 274),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7025, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6141, 150),
      ))
    }

@delegate:ResourceContentHash(1_262_965_197)
internal val Res.string.people_map_visibility_area: StringResource by lazy {
      StringResource("string:people_map_visibility_area", "people_map_visibility_area", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9618, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7430, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6494, 54),
      ))
    }

@delegate:ResourceContentHash(-1_824_253_449)
internal val Res.string.people_map_visibility_area_desc: StringResource by lazy {
      StringResource("string:people_map_visibility_area_desc", "people_map_visibility_area_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9406, 211),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7266, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6350, 143),
      ))
    }

@delegate:ResourceContentHash(-954_793_250)
internal val Res.string.people_map_visibility_city: StringResource by lazy {
      StringResource("string:people_map_visibility_city", "people_map_visibility_city", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9881, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7657, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6701, 46),
      ))
    }

@delegate:ResourceContentHash(727_556_759)
internal val Res.string.people_map_visibility_city_desc: StringResource by lazy {
      StringResource("string:people_map_visibility_city_desc", "people_map_visibility_city_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9665, 215),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7477, 179),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6549, 151),
      ))
    }

@delegate:ResourceContentHash(-2_074_843_999)
internal val Res.string.people_map_zoom_in: StringResource by lazy {
      StringResource("string:people_map_zoom_in", "people_map_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9944, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7720, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6748, 38),
      ))
    }

@delegate:ResourceContentHash(238_889_390)
internal val Res.string.people_map_zoom_out: StringResource by lazy {
      StringResource("string:people_map_zoom_out", "people_map_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9999, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7763, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6787, 39),
      ))
    }

@delegate:ResourceContentHash(700_703_097)
internal val Res.string.people_open_profile_a11y: StringResource by lazy {
      StringResource("string:people_open_profile_a11y", "people_open_profile_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10055, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7811, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6827, 48),
      ))
    }

@delegate:ResourceContentHash(772_191_497)
internal val Res.string.people_save: StringResource by lazy {
      StringResource("string:people_save", "people_save", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10124, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7864, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6876, 27),
      ))
    }

@delegate:ResourceContentHash(1_481_869_371)
internal val Res.string.people_title: StringResource by lazy {
      StringResource("string:people_title", "people_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10160, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7900, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6904, 44),
      ))
    }

@delegate:ResourceContentHash(589_853_691)
internal val Res.string.people_view_map: StringResource by lazy {
      StringResource("string:people_view_map", "people_view_map", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10221, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7945, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6949, 39),
      ))
    }

@delegate:ResourceContentHash(-1_017_517_261)
internal val Res.string.people_visible_toggle: StringResource by lazy {
      StringResource("string:people_visible_toggle", "people_visible_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10496, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8140, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7112, 65),
      ))
    }

@delegate:ResourceContentHash(-1_405_264_466)
internal val Res.string.people_visible_toggle_desc: StringResource by lazy {
      StringResource("string:people_visible_toggle_desc", "people_visible_toggle_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10277, 218),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7993, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6989, 122),
      ))
    }

@delegate:ResourceContentHash(1_234_592_299)
internal val Res.string.person_about: StringResource by lazy {
      StringResource("string:person_about", "person_about", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10606, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8214, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7178, 28),
      ))
    }

@delegate:ResourceContentHash(2_095_768_974)
internal val Res.string.person_avatar_a11y: StringResource by lazy {
      StringResource("string:person_avatar_a11y", "person_avatar_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10643, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8247, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7207, 54),
      ))
    }

@delegate:ResourceContentHash(-77_342_557)
internal val Res.string.person_details: StringResource by lazy {
      StringResource("string:person_details", "person_details", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10706, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8306, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7262, 34),
      ))
    }

@delegate:ResourceContentHash(-1_583_458_785)
internal val Res.string.person_error: StringResource by lazy {
      StringResource("string:person_error", "person_error", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10745, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8341, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7297, 60),
      ))
    }

@delegate:ResourceContentHash(541_373_550)
internal val Res.string.person_hometown: StringResource by lazy {
      StringResource("string:person_hometown", "person_hometown", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10818, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8406, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7358, 35),
      ))
    }

@delegate:ResourceContentHash(-6_442_344)
internal val Res.string.person_interests: StringResource by lazy {
      StringResource("string:person_interests", "person_interests", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10858, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8454, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7394, 36),
      ))
    }

@delegate:ResourceContentHash(891_042_751)
internal val Res.string.person_lang_en: StringResource by lazy {
      StringResource("string:person_lang_en", "person_lang_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10923, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8495, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7431, 34),
      ))
    }

@delegate:ResourceContentHash(349_649_487)
internal val Res.string.person_lang_fa: StringResource by lazy {
      StringResource("string:person_lang_fa", "person_lang_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10966, 38),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8530, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7466, 30),
      ))
    }

@delegate:ResourceContentHash(1_735_552_202)
internal val Res.string.person_lang_fr: StringResource by lazy {
      StringResource("string:person_lang_fr", "person_lang_fr", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11005, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8561, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7497, 30),
      ))
    }

@delegate:ResourceContentHash(-1_182_737_932)
internal val Res.string.person_not_found_desc: StringResource by lazy {
      StringResource("string:person_not_found_desc", "person_not_found_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11048, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8596, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7528, 89),
      ))
    }

@delegate:ResourceContentHash(-1_054_342_721)
internal val Res.string.person_not_found_title: StringResource by lazy {
      StringResource("string:person_not_found_title", "person_not_found_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11166, 82),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8686, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7618, 58),
      ))
    }

@delegate:ResourceContentHash(-266_988_923)
internal val Res.string.person_photo_a11y: StringResource by lazy {
      StringResource("string:person_photo_a11y", "person_photo_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11249, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8745, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7677, 45),
      ))
    }

@delegate:ResourceContentHash(1_691_822_100)
internal val Res.string.person_photo_counter: StringResource by lazy {
      StringResource("string:person_photo_counter", "person_photo_counter", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11299, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8791, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7723, 44),
      ))
    }

@delegate:ResourceContentHash(923_613_815)
internal val Res.string.person_photos: StringResource by lazy {
      StringResource("string:person_photos", "person_photos", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11348, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8840, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7768, 29),
      ))
    }

@delegate:ResourceContentHash(-463_727_049)
internal val Res.string.person_relationship_in_relationship: StringResource by lazy {
      StringResource("string:person_relationship_in_relationship", "person_relationship_in_relationship", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11390, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8870, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7798, 67),
      ))
    }

@delegate:ResourceContentHash(-1_363_140_489)
internal val Res.string.person_relationship_married: StringResource by lazy {
      StringResource("string:person_relationship_married", "person_relationship_married", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11454, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8926, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7866, 47),
      ))
    }

@delegate:ResourceContentHash(2_144_130_699)
internal val Res.string.person_relationship_single: StringResource by lazy {
      StringResource("string:person_relationship_single", "person_relationship_single", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11506, 46),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8974, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7914, 42),
      ))
    }

@delegate:ResourceContentHash(-2_029_959_231)
internal val Res.string.person_retry: StringResource by lazy {
      StringResource("string:person_retry", "person_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11553, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9025, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7957, 32),
      ))
    }

@delegate:ResourceContentHash(-1_987_303_783)
internal val Res.string.person_speaks: StringResource by lazy {
      StringResource("string:person_speaks", "person_speaks", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11602, 49),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9062, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7990, 37),
      ))
    }

@delegate:ResourceContentHash(1_496_420_641)
internal val Res.string.person_viewer_close_a11y: StringResource by lazy {
      StringResource("string:person_viewer_close_a11y", "person_viewer_close_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11652, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9100, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8028, 40),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("people_map_pin_a11y", Res.string.people_map_pin_a11y)
  map.put("people_map_title", Res.string.people_map_title)
  map.put("people_map_toggle", Res.string.people_map_toggle)
  map.put("people_map_toggle_desc", Res.string.people_map_toggle_desc)
  map.put("people_map_visibility_area", Res.string.people_map_visibility_area)
  map.put("people_map_visibility_area_desc", Res.string.people_map_visibility_area_desc)
  map.put("people_map_visibility_city", Res.string.people_map_visibility_city)
  map.put("people_map_visibility_city_desc", Res.string.people_map_visibility_city_desc)
  map.put("people_map_zoom_in", Res.string.people_map_zoom_in)
  map.put("people_map_zoom_out", Res.string.people_map_zoom_out)
  map.put("people_open_profile_a11y", Res.string.people_open_profile_a11y)
  map.put("people_save", Res.string.people_save)
  map.put("people_title", Res.string.people_title)
  map.put("people_view_map", Res.string.people_view_map)
  map.put("people_visible_toggle", Res.string.people_visible_toggle)
  map.put("people_visible_toggle_desc", Res.string.people_visible_toggle_desc)
  map.put("person_about", Res.string.person_about)
  map.put("person_avatar_a11y", Res.string.person_avatar_a11y)
  map.put("person_details", Res.string.person_details)
  map.put("person_error", Res.string.person_error)
  map.put("person_hometown", Res.string.person_hometown)
  map.put("person_interests", Res.string.person_interests)
  map.put("person_lang_en", Res.string.person_lang_en)
  map.put("person_lang_fa", Res.string.person_lang_fa)
  map.put("person_lang_fr", Res.string.person_lang_fr)
  map.put("person_not_found_desc", Res.string.person_not_found_desc)
  map.put("person_not_found_title", Res.string.person_not_found_title)
  map.put("person_photo_a11y", Res.string.person_photo_a11y)
  map.put("person_photo_counter", Res.string.person_photo_counter)
  map.put("person_photos", Res.string.person_photos)
  map.put("person_relationship_in_relationship", Res.string.person_relationship_in_relationship)
  map.put("person_relationship_married", Res.string.person_relationship_married)
  map.put("person_relationship_single", Res.string.person_relationship_single)
  map.put("person_retry", Res.string.person_retry)
  map.put("person_speaks", Res.string.person_speaks)
  map.put("person_viewer_close_a11y", Res.string.person_viewer_close_a11y)
}
